import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/auth";
import "firebase/storage";
import "firebase/functions";
import * as config from "@/config";

// firebase init goes here
const firebaseConfig = config.FIREBASE_CONFIG;

// firebase utils
const db = firebase.initializeApp(firebaseConfig).firestore();
const auth = firebase.auth();
const GoogleAuthProvider = new firebase.auth.GoogleAuthProvider();
const GithubAuthProvider = new firebase.auth.GithubAuthProvider();
const storage = firebase.storage();
const functions = firebase.functions();

const storagePut = (path, fileName, file) => {
  return new Promise((resolve) => {
    storage
      .ref()
      .child(path + fileName)
      .put(file)
      .then(() => {
        resolve({ ok: true });
      })
      .catch((error) => {
        resolve({ ok: false, message: error });
      });
  });
};

const storageGetDownloadUrl = (path) => {
  return new Promise((resolve) => {
    storage
      .ref()
      .child(path)
      .getDownloadURL()
      .then((url) => {
        resolve({ ok: true, data: url });
      })
      .catch(() => {
        resolve({ ok: false });
      });
  });
};

const storageDelete = (path) => {
  return new Promise((resolve) => {
    storage
      .ref()
      .child(path)
      .delete()
      .then((url) => {
        resolve({ ok: true });
      })
      .catch(() => {
        resolve({ ok: false });
      });
  });
};

export {
  db,
  auth,
  GoogleAuthProvider,
  GithubAuthProvider,
  storage,
  storagePut,
  storageGetDownloadUrl,
  storageDelete,
  functions,
};
